var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"services"},_vm._l((_vm.partyServices),function(service){return _c('div',{key:service,staticClass:"service"},[_c('Icon',{attrs:{"iconId":service === 'umg_hls' ? 'video' : service,"isCircle":true,"backgroundColor":_vm.visualPrimaryColor}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }